<script>
import { mapActions, mapGetters } from 'vuex'
import helper from './helper'

export default {
  name: 'cart-btn',
  mixins: [helper],
  computed: {
    ...mapGetters('cart', ['cartCount', 'cartItems'])
  },
  async mounted () {
    await this.cartSubscription()
  },
  methods: {
    ...mapActions('cart', ['cartSubscription']),
    onViewCartHandler () {
      if (this.$route.name !== 'cart.list')
        this.$router.push({ name: 'cart.list' })
    }
  }
}
</script>
<template>
  <b-btn
    v-on:click="onViewCartHandler"
    class="header-cartItem noti-icon"
    style="position: relative"
    variant="black"
  >
    <i class="bx bx-cart" :class="{ 'bx-tada': cartCount > 0 }"></i>
    <b-badge variant="danger" pill v-if="cartCount > 0">{{
      cartCount
    }}</b-badge>
    <!-- cartItem-->
  </b-btn>
</template>
